var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},[_c('alerts',{attrs:{"preselected-services":_vm.selectedServices}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }